<div class="series">Angular Community</div>
<div class="event-details">
  <ng-container *ngIf="event.title === 'Main'; else titleAndDate">
    <div class="event-title" style="margin-bottom: 1em">{{ event.date | date: 'longDate'}}</div>
  </ng-container>
  <ng-template #titleAndDate>
    <div class="event-title">{{event.title }}</div>
    <div class="event-date">{{ event.date | date: 'longDate' }}</div>
  </ng-template>
  <div class="event-time" *ngIf="event.time">{{ event.time }}</div>
  <p class="speaker-name">{{ event.speaker1 }}</p>
  <p class="segment-description">{{ event.description1 }}</p>
  <p class="speaker-name">{{ event.speaker2 }}</p>
  <p class="segment-description">{{ event.description2 }}</p>
  <p class="speaker-name">{{ event.speaker3 }}</p>
  <p class="segment-description">{{ event.description3 }}</p>
  <p class="speaker-name">{{ event.speaker4 }}</p>
  <p class="segment-description">{{ event.description4 }}</p>
  <div class="buttons-container" *ngIf="event.meetupId">
    <a
      mat-stroked-button
      color="primary"
      (click)="eventRSVPClicked(event.meetupId)"
    >
      <span *ngIf="!isPastEvent; else moreEventDetailsTemplate">
        RSVP Here
      </span>
      <mat-icon>open_in_new</mat-icon>
    </a>
    <a
      *ngIf="isPastEvent && event.youtubeId"
      mat-stroked-button
      color="accent"
      (click)="eventWatchClicked(event.youtubeId)"
    >
      Watch Recording
      <mat-icon>open_in_new</mat-icon>
    </a>
  </div>
</div>

<ng-template #moreEventDetailsTemplate> More Event Details </ng-template>
